import { atom } from 'recoil';

import { OrderData, OrderStatus } from './types';

export const orderStatusState = atom<OrderStatus>({
  key: 'orderStatusState',
  default: {
    label: 'Conclua sua boleta',
    status: 'locked',
  },
});

export const orderItemState = atom({
  key: 'orderItemState',
  default: {} as OrderData,
});
